var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"icon":"","fab":"","small":"","to":{ name: `alerts.index` }}},[_c('v-icon',{staticClass:"blue-grey--text text--lighten-2"},[_vm._v("mdi-arrow-left")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }